const REQUEST_STATUS = {
    NEW: 'NEW',
    OFFER_CREATED: 'OFFER_CREATED',
    CREDIBILITY_CHECK: 'CREDIBILITY_CHECK',
    PAYMENT: 'PAYMENT',
    CHOOSE_DELIVERY: 'CHOOSE_DELIVERY',
    DELETED: 'DELETED'
};

exports = module.exports = {
    REQUEST_STATUS
}